"use client";

import { TOP_BANNER_METADATA } from "@/constants/components/topBanner";
import { useAppContext } from "@/context/AppContext";
import { useExperienceMode } from "@/context/ExperienceModeContext";
import { useMonarchMetadata } from "@/context/MonarchMetadataContext";
import cn from "@/lib/cn";
import fireElementClicked from "@/lib/tagular/fire-element-clicked";
import { resolveXfinityClickOffUrl } from "@/lib/clickthrough-destination";
import React from "react";
import PhoneNumber from "../PhoneNumber";
import type { TopBannerProps } from "./types";

const TopBanner: React.FC<TopBannerProps> = ({
  eyebrowText = TOP_BANNER_METADATA.eyebrowText,
  mainText = TOP_BANNER_METADATA.mainText,
  orderLinkUrl = TOP_BANNER_METADATA.orderLinkUrl,
  orderLinkText = TOP_BANNER_METADATA.orderLinkText,
  prePhoneCopy = TOP_BANNER_METADATA.prePhoneCopy,
  showPhoneCta = true,
  className = "",
}) => {
  const { localizationType } = useAppContext();
  const { cartHeavy } = useExperienceMode();
  const monarchMetadata = useMonarchMetadata();
  const resolvedOrderLinkUrl = resolveXfinityClickOffUrl(orderLinkUrl);
  const shouldShowPhoneCta = !cartHeavy && (showPhoneCta ?? true);
  const shouldShowPrePhoneCopy = !cartHeavy && Boolean(prePhoneCopy);

  return (
    <div className={cn(`w-full mx-auto bg-fill-theme1-base`, className)}>
      <div className="">
        <div className="mx-6 xl:mx-16">
          <div className="w-full mx-auto flex justify-center">
            <div className="py-4 text-neutral-base dark text-center xjs-icon-stack-block z-10 xjs-icon-stack-block--1000">
              <div className="flex flex-col gap-4">
                {eyebrowText ? (
                  <h3 className="text-headline3" data-testid="eyebrow-text">
                    {eyebrowText}
                  </h3>
                ) : null}
                <h2 className="text-body2" data-testid="header-text">
                  <p className="text-base">
                    {mainText && mainText?.length > 0 && <>{mainText} </>}
                    <a
                      href={resolvedOrderLinkUrl}
                      className="text-white"
                      onClick={() =>
                        fireElementClicked({
                          actionOutcome: localizationType === "full"
                            ? "sentToOffers"
                            : "sentToLocalize",
                          elementType: "textLink",
                          name: "textLinkHeaderLocalize",
                          location: "banner",
                          text: orderLinkText,
                          outboundUrl: resolvedOrderLinkUrl,
                          ...(monarchMetadata && { monarchMetadata }),
                        })
                      }
                    >
                      <strong>{orderLinkText}</strong>
                    </a>
                    {shouldShowPrePhoneCopy ? (
                      <span>{prePhoneCopy}</span>
                    ) : null}
                    {shouldShowPhoneCta ? (
                      <>
                        <PhoneNumber
                          className="text-white"
                          tagularProps={{
                            location: "banner",
                            name: "phoneNumberHeader",
                            ...(monarchMetadata && { monarchMetadata }),
                          }}
                        />
                        .
                      </>
                    ) : null}
                  </p>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
